/**
 * Message DTO matching backend MessageModel.
 * Types align with backend MessageType enum: ERROR, WARNING, INFO, UPDATE, SUCCESS
 */
export interface MessageDto {
    type: MessageType;
    channel: MessageChannel;
    message: string;
}

export enum MessageType {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    UPDATE = 'UPDATE',
    SUCCESS = 'SUCCESS'
}

export enum MessageChannel {
    PASSWORD_RESET = 'PASSWORD_RESET',
    USER_NOTIFICATION = 'USER_NOTIFICATION'
}
